export default __webpack_public_path__ + "static/FLICKER LAMINATE-d0d4373b9c7378880c159e9e4b8a3416.webp";